export default __webpack_public_path__ + "static/media/image_unavailable.e0ff660a.jpg";